export const NAV_CONFIG = {
  home: 'home',
  myAccount: 'myAccount',
  myStaff: 'myStaff',
  myAccountOverview: 'myAccountOverview',
  securityInfo: 'security-info',
  devices: 'device-list',
  password: 'password',
  organizations: 'organizations',
  settingsAndPrivacy: 'settingsPrivacy',
  mySignIns: 'recent-activity',
  myApps: 'myApps',
  myGroups: 'myGroups',
  myGroupsOverview: 'myGroupsOverview',
  groupsIOwn: 'groups-i-own',
  groupsIAmIn: 'groups-i-belong-to',
  deletedGroups: 'deleted-groups',
  requests: 'requests',
  myAccess: 'myAccess',
  myAccessOverview: 'myAccessOverview',
  accessPackages: 'access-packages',
  requestHistory: 'request-history',
  approvals: 'approvals',
  accessReviews: 'access-reviews',
  showMore: 'showMore',
  manageAgents: 'manageAgents',
};
export enum MSGraphScopes {
  AgentIdentityReadAll = 'AgentIdentity.Read.All',
}
export const MANAGEAGENTS = {
  AGENT_IDENTITY_SERVICE_PRINCIPAL_TYPE: 'ServiceIdentity'
}